import React from 'react';
import { Button, Stack } from '@mui/material';
import { STATE_AID_CERTIFICATE_TYPE_OPTIONS } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/stateAidReceived/constants.ts';
import type { StateAidCertificateType } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/stateAidReceived/types.ts';

interface IStateAidCertificateTypeSelectorProps {
  value?: StateAidCertificateType;
  onChange: (type: StateAidCertificateType) => void;
}

export const StateAidCertificateTypeSelector: React.FC<IStateAidCertificateTypeSelectorProps> = ({
  value,
  onChange,
}) => (
  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ mb: 2 }}>
    {STATE_AID_CERTIFICATE_TYPE_OPTIONS.map((option) => (
      <Button
        key={option.value}
        variant={value === option.value ? 'contained' : 'outlined'}
        onClick={() => onChange(option.value)}
        sx={{ flex: 1, textAlign: 'left', justifyContent: 'flex-start' }}
      >
        {option.label}
      </Button>
    ))}
  </Stack>
);
